import React, {useEffect } from "react";
import { Tag } from '@kui-react/tag'
import { Flex } from '@kui-react/flex'
import "../filterBubble/bubble.css";
import { LeftMenuContext } from "../../context/LeftMenuContext";
import { useSearchParams, useLocation } from "react-router-dom";
const Index = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    console.log("searchParams",searchParams);
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const resetFilter = () => {
        props?.setCatWithSubCat([])
    }
    const clickHandler = (sidecategory, subCategory, catId, event) => {     
            let list = [];
            //let new_list = list.filter((f) => f.subCategory !== subCategory);
            const searchPrms = {};
            const unique_cats = [
                ...new Set(props.catWithSubCat.map((item) => item.category)),
            ];
            unique_cats.forEach((cat) => {
                const sub_cats = props.catWithSubCat.filter(
                    (item) => item.category === cat
                );
                const unique_subcats = [
                    ...new Set(sub_cats.map((item) => item.subCategory)),
                ].filter(item => item !== subCategory).join(",");
                if(unique_subcats.length>0){ searchPrms[cat] = unique_subcats;
            }
            });

            setSearchParams({ ...searchPrms, tab_id: urlParams.has("tab_id") ? urlParams.get("tab_id") :''});
            //sideBarState.setCatWithSubCat(props.catWithSubCat);
            sideBarState.setCatWithSubCat(list);
            props.setFilterFlag(false)
  
            return
    };
    const sideBarState = React.useContext(LeftMenuContext);
    const {
        catWithSubCat,
        // setCatWithSubCat,
    } = sideBarState;
    /* eslint-disable no-useless-concat */
    let uniqueCatWithSubCat = Array.from(new Set(props.catWithSubCat.map(JSON.stringify))).map(JSON.parse);
    /* eslint-enable no-useless-concat */
    useEffect(() => {
          // eslint-disable-next-line react-hooks/exhaustive-deps
        uniqueCatWithSubCat = Array.from(new Set(props.catWithSubCat.map(JSON.stringify))).map(JSON.parse);
    }, [props.catWithSubCat]);
    return (
        <div className="nv-filter-bubble nv-col-12">
            <Flex
                direction="row"
                gap="sm"
                style={{ 'display': 'inline-block' }}
            >
                {

                    uniqueCatWithSubCat.map((filter, i) => {
                        return <Tag
                            className="nv-col-3 nv-bubble-button"
                            dismissible
                            kind="outline"
                            size="standard"
                            onClick={(event) =>
                                clickHandler(
                                    filter.category,
                                    filter.subCategory,
                                    filter.filterField,
                                    event
                                )
                            }
                        >
                            {'' + filter?.category?.toUpperCase() + ': ' + filter.subCategory?.toUpperCase()}
                        </Tag>


                    })

                }
                {catWithSubCat.length >= 1 && <Tag
                    dismissible
                    color="white"
                    kind="outline"
                    size="standard"
                    onClick={() => resetFilter()}
                    className="nv-clear-button"
                >
                    Clear All
                </Tag>}

            </Flex></div>
    )
}
export default Index;